const React = require('react');
const SearchIcon = require('@material-ui/icons/Search').default;


module.exports = ({
  className,
  ...props
}) => {
  return (
    <div className={`rlv ` + (props.disabled ? 'disabled ' : '') + (className || '')}>
      <input
        {...props}
        className="f12 ff$3 h45 w pl25 pr70 bs b1 bc8
          olN cCT (cCT|o100):i r9 dn bc0:(h|f)<1:not[.disabled] o50<1.disabled"
      />
      <div className="layoutRow fhaC fvaC bg5B47FF abs w45 svr r0_9_9_0 bgA3A7AC<1.disabled">
        <SearchIcon className="sq21*2 cF"/>
      </div>
    </div>
  );
};
